import { render } from "./workBook.vue?vue&type=template&id=70346f45&scoped=true"
import script from "./workBook.vue?vue&type=script&lang=js"
export * from "./workBook.vue?vue&type=script&lang=js"

import "./workBook.vue?vue&type=style&index=0&id=70346f45&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70346f45"]])

export default __exports__